import { type CSSProperties } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import { makeStyles } from 'tss-react/mui';
import { getColors } from '@mercedes-benz/odp-theme-v2';
import { parseOwnerRef } from '../catalog/hooks/catalogUtils';

interface OwnerLinkProps {
  owner: string;
  color?: string;
  style?: CSSProperties;
  className?: string;
}

const useStyles = makeStyles()(() => ({
  link: {
    cursor: 'pointer',
    textDecoration: 'none',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
}));

export const OwnerLink = ({
  owner,
  color,
  style,
  className,
}: Readonly<OwnerLinkProps>) => {
  const navigate = useNavigate();
  const theme = useTheme();
  const c = getColors(theme.palette.mode);
  const { classes, cx } = useStyles();

  if (!owner || owner === '-') {
    return <span style={style}>{owner}</span>;
  }

  const parsed = parseOwnerRef(owner);
  if (!parsed) {
    return <span style={style}>{owner}</span>;
  }

  const { displayName, path } = parsed;
  return (
    <span
      role="link"
      tabIndex={0}
      className={cx(classes.link, className)}
      style={{
        color: color ?? c.text.link,
        ...style,
      }}
      onClick={e => {
        e.stopPropagation();
        navigate(path);
      }}
      onKeyDown={e => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.stopPropagation();
          navigate(path);
        }
      }}
    >
      {displayName}
    </span>
  );
};
